import { IReduxAction, actionGenerator } from '../../redux/actionGenerator';
import { IRosreestrData } from '../../services/rosreestrData';

export const SET_ROSREESTR_DATA = 'ROSREESTR_DATA :: SET';

type TRosreestrData = Partial<Omit<IRosreestrData, 'meta'>>;

export type TSetRosreestrDataAction = IReduxAction<typeof SET_ROSREESTR_DATA, TRosreestrData>;

export const setRosreestrData = actionGenerator<typeof SET_ROSREESTR_DATA, TRosreestrData>(SET_ROSREESTR_DATA);
